import ReportableException from '@/exceptions/ReportableException'

class SupportableException extends ReportableException {
  public name = 'SupportableException'
}

export default SupportableException
